import { Trans } from 'react-i18next';

const Notice = () => {
    return (
        <p className="text-sm text-black045 leading-normal mt-[20px] mx-[16px] pl-[9px] lg:mx-0 lg:mt-[16px] relative before:content-[''] before:inline-block before:bg-dot before:w-[3px] before:h-[3px] before:absolute before:left-0 before:top-[9px]">
            <Trans components={{ span: <span /> }} i18nKey={'I019'} />
        </p>
    );
};
export default Notice;

// 연대기를 완료한 서버에는 신규 이벤트가 추가됩니다. <span className="block lg:hidden"></span>따라서 서버 마다 진행되는 이벤트가 다를 수 있습니다.
